import { HttpInterceptorFn } from '@angular/common/http';
import {inject, NgZone} from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

let isRedirecting = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const ngZone = inject(NgZone);
  return next(req).pipe(
    catchError(err => {
      if (err.status === 401) {

        if (!isRedirecting) {
          isRedirecting = true;
          setTimeout(() => {
            ngZone.run( () => {
              window.location.href = '';
            })
          });
        }
      }
      return throwError(() => err);
    })
  );
};
